import qs from 'qs';

import type { IStringifyOptions } from 'qs';

/** @knipignore - will be used */
export const stringifyQuery = <T>(obj: T, options?: IStringifyOptions): string => qs.stringify(obj, options);
